import { Item } from 'apis/restaurant-api/merchant-admin/menu2/types';

export type HeaderData = {
  type: 'header';
  data: {
    id: string;
    name: string;
    itemIds: string[];
  };
};

export type ItemData = {
  type: 'item';
  data: Item;
  areaId: string;
};

export type ListElement = ItemData | HeaderData;

export enum DnD {
  Area = 'area',
  SingleItem = 'single-item',
  MultiItems = 'multiple-items',
  Dropzone = 'dropzone',
}
